// extracted by mini-css-extract-plugin
export var contentSwitcherSection = "ContentSwitcher-module--contentSwitcherSection--G8MZw";
export var float = "ContentSwitcher-module--float--SsI0F";
export var contentSwitcherTrigger = "ContentSwitcher-module--contentSwitcherTrigger--W4_DE";
export var icon = "ContentSwitcher-module--icon--1WUuA";
export var contentSwitcherBody = "ContentSwitcher-module--contentSwitcherBody--2DF7M";
export var accordionHeader = "ContentSwitcher-module--accordionHeader--et5R7";
export var accordionHeaderTitle = "ContentSwitcher-module--accordionHeaderTitle--C4u6b";
export var arrow = "ContentSwitcher-module--arrow--2xQ7K";
export var completedModule = "ContentSwitcher-module--completedModule--JnrcO";